<template>
  <div>
    <QrcodeStream @decode="onDecode"></QrcodeStream>
  </div>
</template>
<script>
console.log("ICI");
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: "Wahoo Scan",
  components: {
    QrcodeStream,
  },
  data: function() {
    return {
      
    };
  },
  methods: {
    onDecode (decodedString) {
      if(decodedString.length == "5f3f8b07b080ef001752ae87".length) {
        this.$router.replace('/whaooform/'+decodedString);
      }
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          alert("ERROR: you need to grant camera access permisson");
        } else if (error.name === 'NotFoundError') {
          alert("ERROR: no camera on this device");
        } else if (error.name === 'NotSupportedError') {
          alert("ERROR: secure context required (HTTPS, localhost)");
        } else if (error.name === 'NotReadableError') {
          alert("ERROR: is the camera already in use?");
        } else if (error.name === 'OverconstrainedError') {
          alert("ERROR: installed cameras are not suitable");
        } else if (error.name === 'StreamApiNotSupportedError') {
          alert("ERROR: Stream API is not supported in this browser");
        }
      }
    }
  },
  computed: {
    list() {
      
    }
  },
  mounted () {
    console.log("MOUNTEDDD")
  },
  created: function() {

  }
}
</script>
<style>
button {
  margin-top:20px;
}
</style>